import React, { useState, useEffect } from "react";
import "../App.css";

import Axios from "axios";

import {
    MDBTableHead,
    MDBTableBody,
    MDBBtn,
    MDBTable,
    MDBInput,
    MDBPagination,
    MDBPaginationItem, MDBPaginationLink
} from "mdb-react-ui-kit";
import {Link, useNavigate} from "react-router-dom";
import {backendPathCustomers, ENTRIES_PER_PAGE} from "../Constants";
import {matchesSearch} from "../functions/matchPerson";
import {calcAge} from "../functions/date";
import {checkVisibility} from "../functions/visibility";
import {getPaginationNumbers} from "../functions/pagination";
import {loadPermissions} from "../functions/permissions";
import TopNavbar from "../components/Navbar";


function Customers() {
    const navigate = useNavigate();

    const [customerList, setCustomerList] = useState([]);
    const [filteredCustomersList, setFilteredCustomersList] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [startIndex, setStartIndex] = useState(0);
    const [numberOfCustomers, setNumberOfCustomers] = useState(0);
    const [pageNumbers, setPageNumbers] = useState([]);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);

    const getCustomers = () => {
        Axios.get(backendPathCustomers+"customers.php").then((response) => {
            setCustomerList(response.data);

            setFilteredCustomersList(response.data
                .filter(value => matchesSearch(value, searchValue))
                .filter(value => checkVisibility(value["PartnerID"], "partner"))
                .filter(value => checkVisibility(value["OfficeEmployeeID"], "officeEmployee")));
        });
    };

    useEffect(() => {
        loadPermissions(navigate, setReadPermission, setWritePermission);
        getCustomers();
    }, []);

    useEffect(() => {
        console.log("effect 4");
        setNumberOfCustomers(filteredCustomersList.length);
    }, [filteredCustomersList]);

    useEffect(() => {
        console.log("effect 2");
        setPageNumbers(getPaginationNumbers(numberOfCustomers, ENTRIES_PER_PAGE));
    }, [numberOfCustomers]);

    useEffect(() => {
        console.log("effect 3 filter ", customerList);
        setFilteredCustomersList(customerList.filter(value => matchesSearch(value, searchValue))
                                             .filter(value => checkVisibility(value["PartnerID"], "partner"))
                                             .filter(value => checkVisibility(value["OfficeEmployeeID"], "officeEmployee")));
        setStartIndex(0);
    }, [searchValue]);

    return (
        <>
        <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
        <div className="main">
            <div className="header-above-table d-flex align-items-center">
                <h2>Liste aller Kunden</h2>
                <div className="search-btns">
                    <MDBInput label='Suche' type='text' onChange={(e) => setSearchValue(e.target.value)}/>
                </div>
                <Link className="right" to="/new-customer">
                    <MDBBtn className="">Hinzufügen</MDBBtn>
                </Link>
            </div>

            <MDBTable align='middle'>
                <MDBTableHead className="table-head">
                    <tr className="underlined-header">
                        <th scope='col'>Name</th>
                        <th scope='col'>Vorname</th>
                        <th scope='col'>Partner</th>
                        <th scope='col'>Mitarbeiter</th>
                        <th scope='col'>Alter</th>
                        <th scope='col'>Adresse</th>
                        <th scope='col'>Pflegegrad</th>
                        <th scope='col'>Personen</th>
                        <th scope='col'>Status</th>
                        <th scope='col'></th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    <tr className="table-body">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    {filteredCustomersList
                        .slice(startIndex, startIndex + ENTRIES_PER_PAGE)
                        .map((val, key) => {
                            return (
                                <tr className={Number(val.Inactive) ? "inactive" : ""} key={key}>
                                    <td>{val.LastName}</td>
                                    <td>{val.FirstName}</td>
                                    <td>{val.Partner ? val.Partner : "-"}</td>
                                    <td>{val.OfficeEmployeeFirstName ? val.OfficeEmployeeFirstName + " " + val.OfficeEmployeeLastName : "-"}</td>
                                    <td>{calcAge(val.Birthday)}</td>
                                    <td>{val.Street} {val.HouseNumber}<br></br>{val.ZIP} {val.City}</td>
                                    <td>{val.DegreeOfCare}</td>
                                    <td>{1 + Number(val.SecondPerson)}</td>
                                    <td>{Number(val.Inactive) ? "inaktiv" : "aktiv"}</td>
                                    <td>
                                        <Link to={'/customer/' + val.CustomerID}>Details</Link>
                                    </td>
                                </tr>
                            );
                        })}
                </MDBTableBody>
            </MDBTable>


            <nav className="page-selection-aria">
                <MDBPagination className='page-selection'>
                    <MDBPaginationItem disabled={startIndex <= 0}
                                       onClick={() => {
                                           if (startIndex >= ENTRIES_PER_PAGE) {
                                               setStartIndex(startIndex - ENTRIES_PER_PAGE)
                                           }
                                       }}>
                        <MDBPaginationLink>Zurück</MDBPaginationLink>
                    </MDBPaginationItem>

                    {
                        pageNumbers.map((val, key) => {
                            if (val === -1) {
                                return (
                                    <p className={"pt-1 ms-2 me-2 paging-dots"}>...</p>
                                );
                            } else {
                                return (
                                    <MDBPaginationItem key={key} onClick={() => {
                                        setStartIndex((val - 1) * ENTRIES_PER_PAGE);
                                    }}>
                                        <MDBPaginationLink>{val}</MDBPaginationLink>
                                    </MDBPaginationItem>
                                );
                            }
                        })
                    }

                    <MDBPaginationItem
                        disabled={startIndex / ENTRIES_PER_PAGE >= Math.ceil(numberOfCustomers / ENTRIES_PER_PAGE) - 1}
                        onClick={() => {
                            if (startIndex / ENTRIES_PER_PAGE < Math.ceil(numberOfCustomers / ENTRIES_PER_PAGE) - 1) {
                                setStartIndex(startIndex + ENTRIES_PER_PAGE)
                            }
                        }}>
                        <MDBPaginationLink>Weiter</MDBPaginationLink>
                    </MDBPaginationItem>
                </MDBPagination>
            </nav>
        </div>
        </>
    );
}

export default Customers;